import { c as _c } from "react/compiler-runtime";
export default function DropListItemContentMediaAudio(t0) {
  const $ = _c(2);
  const {
    src
  } = t0;
  let t1;
  if ($[0] !== src) {
    t1 = <div><audio controls={true} className="tw-w-full tw-max-h-10"><source src={src} type="audio/mpeg" />Your browser does not support the audio element.</audio></div>;
    $[0] = src;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}